module.exports = __webpack_public_path__ + "463171e1a2cec1803c54291b71f62350.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/heart-icon.svg
// module id = 2482
// module chunks = 0